import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Stores IDs of issues that have been deleted in the current session. */
const deleteIssueSlice = createSlice({
  name: "deleteIssueData",
  initialState: [] as string[],
  reducers: {
    setDeleteIssueData: (_state: string[], action: PayloadAction<string[]>) => action.payload,
  },
});

export const { setDeleteIssueData } = deleteIssueSlice.actions;

export const deleteIssueData = deleteIssueSlice.reducer;
